import { Component, Inject, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProgressDialogService } from './progress-dialog.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProgressDialogComponent implements OnInit, OnDestroy {
  progressGoal: number = 0;
  progressValue = 0;
  currentProgress = 0;
  progressSubscription: Subscription = new Subscription();
  message?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private progressDialogService: ProgressDialogService,
  ) {}

  ngOnInit() {
    this.progressGoal = this.data.progressGoal;
    this.message = this.data.message;

    this.progressSubscription = this.progressDialogService.progress$.subscribe((progressCount: number) => {
      this.currentProgress += progressCount;
      this.progressValue = (this.currentProgress / this.progressGoal) * 100;
    });
  }

  ngOnDestroy() {
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }
  }
}
